import { PositionStrategy } from '@angular/cdk/overlay';

export interface ModalConfig {
    id?: string;
    title?: string;
    message?: string;
    variant?: ModalVariants;
    size?: ModalSizes;
    modal?: boolean;
    data?: any;
    disableClose?: boolean;
    closeOnNavigation?: boolean;
    hasBackdrop?: boolean;
    panelClass?: string;
    backdropClass?: string;
    autoFocus?: boolean;
    hasBackButton?: boolean;
    positionStrategy?: PositionStrategy;
    mobileAutoScale?: boolean;
    withoutContentPadding?: boolean;
}

export enum ModalVariants {
    Passive = 'passive',
    Transactional = 'transactional',
    Acknowledgment = 'acknowledgment',
    Progress = 'progress'
}

export enum ModalSizes {
    Slim = 'slim',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
    Dynamic = 'dynamic',
    Mobile = 'mobile',
    Custom = 'custom'
}
